import React from 'react'
import Layout from '../../components/Layout'
import Container from '../../components/Container'
import PageTitle from '../../components/PageTitle'
import BodyPlaceholder from '../../components/BodyPlaceholder'
import UnderConstruction from '../../components/UnderConstruction'
import SEO from '../../components/SEO'

const Column = ({ data }) => {
  return (
    <Layout>
      <SEO title="죠이플 창(窓) | 소식 - 죠이플 교회" description="Joyful Church newsletters" />
        <UnderConstruction title={`소식 / 죠이플 창(窓)`} />
    </Layout>
    // <Layout>
    //   <Container>
    //     <PageTitle>죠이플 창(窓)</PageTitle>
    //     <BodyPlaceholder body={`<div>소식 / 죠이플 창(窓)</div>`} />
    //   </Container>
    // </Layout>
  )
}

export default Column
